var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg38(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.89 1.11c.47.47.77 1.09.84 1.75.36 3.42.36 6.86 0 10.28a2.91 2.91 0 0 1-2.6 2.59c-3.41.36-6.85.36-10.27 0a2.92 2.92 0 0 1-2.59-2.6 48.42 48.42 0 0 1 0-10.27A2.91 2.91 0 0 1 2.87.27c3.41-.36 6.85-.36 10.27 0 .66.07 1.28.37 1.75.84Zm-3.3 3.26L3.91 7.36c-.53.2-.52.5-.1.63l1.97.63 4.57-2.9c.21-.14.41-.06.25.08L6.9 9.17l-.14 2.04c.2 0 .3-.1.4-.2l.97-.93 1.99 1.48c.37.2.62.1.72-.34l1.3-6.23c.12-.53-.2-.75-.55-.62Z",
    fill: "#98A3B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg38);
export default __webpack_public_path__ + "static/media/svg38.4de2ee5f9c01122d8e42cba0a007bb7c.svg";
export { ForwardRef as ReactComponent };